<!-- 此为页面左栏切换组件demo模块 -->


<template>
    <div class="list-box">
        <ul class="list">

            <li>
                <list_card 
                    :order="1" 
                    :card_url="'https://www.baidu.com/'"
                    :title="'马山县不动产登记中心'" 
                    :phone="'07716826889'" 
                    :address="'广西壮族自治区南宁市马山县威马大道198号'">
                </list_card>
            </li>

            <li>
                <list_card 
                    :order="2" 
                    :card_url="'https://www.baidu.com/'"
                    :title="'隆安县不动产登记中心'" 
                    :phone="'0771-6522880'" 
                    :address="'隆安县城厢镇蝶城路201号隆安县政务服务中心4楼不动产登记窗口'">
                </list_card>
            </li>

            <li>
                <list_card 
                    :order="3" 
                    :card_url="'https://www.baidu.com/'"
                    :title="'上林县不动产登记中心'" 
                    :phone="'(0771)5229611'" 
                    :address="'广西南宁市上林县大丰镇新丰路133号'">
                </list_card>
            </li>

            <li>
                <list_card 
                    :order="4" 
                    :card_url="'https://www.baidu.com/'"
                    :title="'南宁市不动产登记中心（园湖受理点）'" 
                    :phone="'(0771)5656969'" 
                    :address="'广西壮族自治区南宁市青秀区园湖北路37-1号'">
                </list_card>
            </li>

            <li>
                <list_card 
                    :order="5" 
                    :card_url="'https://www.baidu.com/'"
                    :title="'南宁市不动产登记中心（青秀受理点）'" 
                    :phone="'(0771)3198123'" 
                    :address="'广西壮族自治区南宁市青秀区民族大道98-1号南宁图书大厦二期(南宁书城金湖南湖店)副楼二层自编号201铺'">
                </list_card>
            </li>

            <li>
                <list_card 
                    :order="6" 
                    :card_url="'https://www.baidu.com/'"
                    :title="'南宁市不动产登记中心'" 
                    :phone="'3198123'" 
                    :address="'广西壮族自治区南宁市青秀区民族大道98-1号南宁图书大厦二期(南宁书城金湖南湖店)副楼二层自编号201铺'">
                </list_card>
            </li>

        </ul>
    </div>
</template>
  
<script>
import list_card from './list_card.vue';

    export default {
    name: "left_cmpt_demo",
    data() {
        return {};
    },
    components:{  
        list_card,
    }
}
</script>
  

<style scoped>
@import '../styles/left_list.css';
</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-pc/left_cmpt_demo/left_cmpt_demo.vue